import { Pipe, PipeTransform, inject } from '@angular/core';
import { Store } from '@ngrx/store';
// TODO: move to ca-ng-core
import { selectLanguage } from '../../../../../apps/design4circularity/src/app/store/selectors';
import { GeneralState } from '../../../../../apps/design4circularity/src/app/store/general.reducer';
import { Observable } from 'rxjs';

@Pipe({
  name: 'languagePrefix',
  standalone: true,
})
export class LanguagePrefixPipe implements PipeTransform {
  private store = inject(Store<{ general: GeneralState }>);
  private language$: Observable<string> = this.store.select(selectLanguage);

  transform(route: string | any[]): Observable<any[]> {
    return new Observable((observer) => {
      this.language$.subscribe((language) => {
        const lang = language || 'en'; // Default to 'en'

        const nxt = typeof route === 'string' ? [`/${lang}`, route] : [`/${lang}`, ...route];
        observer.next(nxt);
      });
    });
  }
}
